import Vue from 'vue';
import Router from 'vue-router';
const HomePage = () => import('@/view/homePage/newHomePage'); // 首页
const BindingPhone = () => import('@/view/bindingPhone/BindingPhone'); // 绑定手机号
const BaseShotList = () => import('@/view/baseShotList/BaseShotList'); // 最佳拍摄点列表
const Feedback = () => import('@/view/feedback/Feedback'); // 意见反馈
const FeedbackBtn = () => import('@/view/feedbackBtn/FeedbackBtn'); // 意见反馈-我要反馈
const Questionnaire = () => import('@/view/questionnaire/Questionnaire'); // 问卷调查
const OneSeekHelp = () => import('@/view/oneSeekHelp/OneSeekHelp'); // 一键求助
const OnlineHelp = () => import('@/view/onlineHelp/OnlineHelp'); // 在线求助
const Enroll = () => import('@/view/enroll/Enroll'); // 立即报名填报
const BigSearch = () => import('@/view/bigSearch/BigSearch'); // 首页大搜索
const Complain = () => import('@/view/complain/Complain'); // 投诉
const MyFeedback = () => import('@/view/myFeedback/MyFeedback'); // 我的反馈
const MyComplain = () => import('@/view/myComplain/MyComplain'); // 我的投诉
const MyHelp = () => import('@/view/myHelp/MyHelp'); // 我的求助
const CustomerService = () => import('@/view/customerService/CustomerService'); // 智能客服
const MyComplainDetails = () => import('@/view/myComplainDetails/MyComplainDetails'); // 我的投诉详情
const MyHelpDetails = () => import('@/view/myHelpDetails/MyHelpDetails'); // 我的求助详情
const ComplainSubmit = () => import('@/view/complainSubmit/ComplainSubmit'); // 提交投诉
const ComplainSubmitWc = () => import('@/view/complainSubmitWc/ComplainSubmitWc'); // 提交投诉
const Parking = () => import('@/view/findParking/index'); // 停车场
const ParkingDetail = () => import('@/view/findParking/parkingDetail'); // 停车场详情
const FindWC = () => import('@/view/findWC'); //  找厕所
const FindWcEv = () => import('@/view/findWC/wcEvaluation'); // 厕所评价
const FindWcDe = () => import('@/view/findWC/wcDetail'); // 厕所详情
const SwitchScenic = () => import('@/view/SwitchScenic/switchScenic'); // 切换景区
const allDiscussList = () => import('@/view/allDiscussList/AllDiscussList'); //全部评论列表
const discussDetails = () => import('@/view/discussDetails/DiscussDetails'); //评论详情
const carParkList = () => import('@/view/carPark/carParkList'); // 停车场订单列表
const carParkDetail = () => import('@/view/carPark/carParkDetail'); // 停车场订单详情
const carParkResult = () => import('@/view/carPark/carParkResult'); // 停车场订单支付结果
const activityList = () => import('@/view/activity/activityList'); // 活动/赛事列表
const myActivityList = () => import('@/view/activity/myActivityList'); // 我的活动/赛事列表
const lineList = () => import('@/view/line/lineList'); // 主题线路
const newStrategyList = () => import('@/view/strategy/strategyList'); // 攻略线路
const mustPlayList = () => import('@/view/mustPlay/mustPlayList'); // 必玩内容
const noticeDetail = () => import('@/view/notice/noticeDetail'); // 公告详情
const noticeList = () => import('@/view/notice/noticeList'); // 公告列表
const userInfo = () => import('@/view/userInfo/userInfo'); // 个人中心
const myCollect = () => import('@/view/myCollection/myCollect'); // 我的收藏
const toastWait = () => import('@/view/commonPage/toastWait'); // 敬请期待页面
const complainSus = () => import('@/view/complain/complainSus'); // 投诉成功页面
const scenicParkList = () => import('@/view/scenicPark/scenicParkList'); // 公园列表
const scenicParkDetail = () => import('@/view/scenicPark/scenicParkDetail'); // 景区名片
const greenCard = () => import('@/view/greenwayCard/greenCard'); // 绿道名片
const scenicSpot = () => import('@/view/details/scenicSpot'); // 景点名片
const lineDetails = () => import('@/view/details/lineDetails'); // 线路详情
const strategyDetails = () => import('@/view/details/strategyDetails'); // 攻略详情
const activityDetails = () => import('@/view/details/activityDetails'); // 活动详情
const bestShotDetail = () => import('@/view/baseShotList/bestShotDetail'); // 拍摄位详情
const newAllVideoPictures = () => import('@/view/allVideoPictures/newAllVideoPictures'); // 全部视频图片
const pageNull = () => import('@/view/commonPage/404'); // 全部视频图片
const qrcodePage = () => import('@/view/commonPage/qrCodePage'); // 扫一扫iframe页

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        title: '首页',
        keepAlive: true
      },
    },
    {
      path: '/activityList',
      name: 'activityList',
      component: activityList,
      meta: {
        title: '活动赛事',
        hideShare: true
      },
    },
    {
      path: '/myActivityList',
      name: 'myActivityList',
      component: myActivityList,
      meta: {
        title: '我的活动赛事',
        hideShare: true
      },
    },
    {
      path: '/lineList',
      name: 'lineList',
      component: lineList,
      meta: {
        title: '主题线路'
      }
    },
    {
      path: '/newStrategyList',
      name: 'newStrategyList',
      component: newStrategyList,
      meta: {
        title: '官方攻略',
        hideShare: true
      }
    },
    {
      path: '/mustPlayList',
      name: 'mustPlayList',
      component: mustPlayList,
      meta: {
        title: '必玩内容',
        hideShare: true
      }
    },
    {
      path: '/noticeDetail',
      name: 'noticeDetail',
      component: noticeDetail,
      meta: {
        title: '公告详情',
        hideShare: true
      }
    },
    {
      path: '/noticeList',
      name: 'noticeList',
      component: noticeList,
      meta: {
        title: '公告',
        hideShare: true
      }
    },
    {
      // 个人中心
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
      meta: {
        title: '个人中心',
        wxAuth: true
      }
    },
    {
      // 我的收藏
      path: '/myCollect',
      name: 'myCollect',
      component: myCollect,
      meta: {
        title: '我的收藏',
        hideShare: true
      }
    },
    // 敬请期待页
    {
      path: '/toastWait',
      name: 'toastWait',
      component: toastWait,
    },
    // 投诉成功页
    {
      path: '/complainSus',
      name: 'complainSus',
      component: complainSus,
      meta: {
        title: '我的投诉',
        hideShare: true
      }
    },
    {
      path: '/scenicParkList',
      name: 'scenicParkList',
      component: scenicParkList,
      meta: {
        title: '全部公园',
        hideShare: true
      }
    },
    {
      path: '/scenicParkDetail',
      name: 'scenicParkDetail',
      component: scenicParkDetail,
      meta: {
        title: '景区名片'
      }
    },
    {
      path: '/greenCard',
      name: 'greenCard',
      component: greenCard,
      meta: {
        title: '绿道名片',
        wxAuth: true
      }
    },
    {
      path: '/scenicSpot',
      name: 'scenicSpot',
      component: scenicSpot,
      meta: {
        title: '景点名片'
      }
    },
    {
      path: '/lineDetails',
      name: 'lineDetails',
      component: lineDetails,
      meta: {
        title: '线路详情'
      }
    },
    {
      path: '/strategyDetails',
      name: 'strategyDetails',
      component: strategyDetails,
      meta: {
        title: '攻略详情'
      }
    },
    {
      path: '/activityDetails',
      name: 'activityDetails',
      component: activityDetails,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/bestShotDetail',
      name: 'bestShotDetail',
      component: bestShotDetail,
      meta: {
        title: '拍摄位详情',
        hideShare: true
      }
    },
    {
      path: '/newAllVideoPictures',
      name: 'newAllVideoPictures',
      component: newAllVideoPictures,
      meta: {
        title: '全部视频/图片'
      }
    },
    {
      // 绑定手机号
      path: '/bindingPhone',
      name: 'bindingPhone',
      component: BindingPhone,
    },
    {
      // 最佳拍摄点列表
      path: '/baseShotList',
      name: 'baseShotList',
      component: BaseShotList,
    },
    {
      // 意见反馈
      path: '/feedback',
      name: 'feedback',
      component: Feedback,
    },
    {
      // 意见反馈-我要反馈
      path: '/feedbackBtn',
      name: 'feedbackBtn',
      component: FeedbackBtn,
    },
    {
      // 问卷调查
      path: '/questionnaire',
      name: 'questionnaire',
      component: Questionnaire,
    },
    {
      // 我的反馈
      path: '/myFeedback',
      name: 'myFeedback',
      component: MyFeedback,
    },
    {
      // 一键求助
      path: '/oneSeekHelp',
      name: 'oneSeekHelp',
      component: OneSeekHelp,
    },
    {
      // 在线求助
      path: '/onlineHelp',
      name: 'onlineHelp',
      component: OnlineHelp,
    },
    {
      // 首页大搜索
      path: '/bigSearch',
      name: 'bigSearch',
      component: BigSearch,
    },
    {
      // 投诉
      path: '/complain',
      name: 'complain',
      component: Complain,
    },
    {
      // 我的投诉
      path: '/myComplain',
      name: 'myComplain',
      component: MyComplain,
    },
    {
      // 我的求助
      path: '/myHelp',
      name: 'myHelp',
      component: MyHelp,
    },
    {
      // 立即报名填报
      path: '/enroll',
      name: 'enroll',
      component: Enroll,
    },
    {
      // 智能客服
      path: '/customerService',
      name: 'customerService',
      component: CustomerService,
    },
    {
      // 我的投诉详情
      path: '/myComplainDetails',
      name: 'myComplainDetails',
      component: MyComplainDetails,
    },
    {
      // 我的求助详情
      path: '/myHelpDetails',
      name: 'myHelpDetails',
      component: MyHelpDetails,
    },
    {
      // 提交投诉
      path: '/complainSubmit',
      name: 'complainSubmit',
      component: ComplainSubmit,
    },
    {
      // 提交厕所投诉
      path: '/complainSubmitWc',
      name: 'complainSubmitWc',
      component: ComplainSubmitWc,
    },
    {
      //停车场
      path: '/parking',
      name: 'parking',
      component: Parking,
      meta: {
        hideShare: true
      }
    },
    {
      //停车场详情
      path: '/parkingDetail',
      name: 'parkingDetail',
      component: ParkingDetail,
    },
    {
      // 找厕所首页
      path: '/findWC',
      name: 'findWC',
      component: FindWC,
      meta: {
        hideShare: true
      }
    },
    {
      //厕所评价
      path: '/wcEvaluation',
      name: 'wcEvaluation',
      component: FindWcEv,
    },
    {
      //厕所详情
      path: '/wcDetail',
      name: 'wcDetail',
      component: FindWcDe,
      meta: {
        title: '找厕所'
      }
    },

    {
      //切换景区
      path: '/switchScenic',
      name: 'switchScenic',
      component: SwitchScenic,
      meta: {
        hideShare: true
      }
    },
    {
      // 全部评论列表
      path: "/allDiscussList",
      name: "allDiscussList",
      component: allDiscussList,
      meta: {
        title: '全部评论',
        wxAuth: true
      }
    },
    {
      // 评论详情
      path: "/discussDetails",
      name: "discussDetails",
      component: discussDetails,
      meta: {
        wxAuth: true
      }
    },
    {
      //停车场订单列表
      path: '/carParkList',
      name: 'carParkList',
      component: carParkList,
      meta: {
        hideShare: true
      }
    },
    {
      //车场车费详情
      path: '/carParkDetail',
      name: 'carParkDetail',
      component: carParkDetail,
      meta: {
        hideShare: true
      }
    },
    {
      // 车费支付结果
      path: '/carParkResult',
      name: 'carParkResult',
      component: carParkResult,
      meta: {
        hideShare: true
      }
    },
    {
      // 车费支付结果
      path: '/404',
      name: '404',
      component: pageNull,
      meta: {
        hideShare: true
      }
    },
    {
      // iframe页
      path: '/qrcodePage',
      name: 'qrcodePage',
      component: qrcodePage,
      meta: {
        hideShare: true
      }
    },
  ],
});
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }
